import React from 'react';
import { motion } from 'framer-motion';

const RecapHero = ({ game, feed }) => {
  const away = game?.teams?.away;
  const home = game?.teams?.home;
  const awayScore = away?.score ?? feed?.liveData?.linescore?.teams?.away?.runs ?? '--';
  const homeScore = home?.score ?? feed?.liveData?.linescore?.teams?.home?.runs ?? '--';
  const awayWon = Number(awayScore) > Number(homeScore);
  const homeWon = Number(homeScore) > Number(awayScore);
  const venue = game?.venue?.name || feed?.gameData?.venue?.name || '--';
  const duration = feed?.gameData?.datetime?.time || null;
  const attendance = feed?.gameData?.gameInfo?.attendance;
  const weather = feed?.gameData?.weather;

  const TeamBlock = ({ team, score, isWinner, side }) => (
    <div className={`flex flex-col items-center flex-1 ${side === 'right' ? 'items-end' : 'items-start'}`}>
      <span className="text-[9px] sm:text-[10px] tracking-[0.3em] uppercase text-[#658d71] font-bold mb-1">
        {side === 'left' ? 'Away' : 'Home'}
      </span>
      <span className={`text-base sm:text-xl font-black uppercase tracking-widest leading-tight text-center ${isWinner ? 'text-[#d8ceb3]' : 'text-[#a9c9b1]'}`}>
        {team?.team?.name || '--'}
      </span>
      <motion.span
        className={`text-4xl sm:text-6xl font-black tabular-nums mt-1 ${isWinner ? 'text-white' : 'text-[#658d71]'}`}
        initial={{ scale: 0.7, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 260, damping: 20, delay: 0.15 }}
      >
        {score}
      </motion.span>
      {isWinner && (
        <span className="mt-1 text-[9px] bg-[#c4333e] text-white px-2 py-0.5 font-black uppercase tracking-widest">
          Winner
        </span>
      )}
    </div>
  );

  return (
    <div className="bg-[rgba(0,0,0,0.15)] border-2 border-[#658d71] p-4 sm:p-6">
      <div className="flex items-center gap-4">
        <TeamBlock team={away} score={awayScore} isWinner={awayWon} side="left" />
        <div className="flex flex-col items-center shrink-0 gap-1">
          <span className="text-[#d8ceb3] text-xl font-black opacity-40">FINAL</span>
          <div className="w-px h-8 bg-[#658d71]" />
          <span className="text-[8px] text-[#658d71] font-bold uppercase tracking-widest">vs</span>
        </div>
        <TeamBlock team={home} score={homeScore} isWinner={homeWon} side="right" />
      </div>
      <div className="mt-4 pt-3 border-t border-[#658d71] grid grid-cols-2 sm:grid-cols-4 gap-2">
        {[
          ['Venue', venue],
          ['Duration', duration ? `${duration}` : '--'],
          ['Attendance', attendance ? Number(attendance).toLocaleString() : '--'],
          ['Weather', weather?.condition ? `${weather.condition}${weather.temp ? `, ${weather.temp}°F` : ''}` : '--'],
        ].map(([label, val]) => (
          <div key={label} className="flex flex-col">
            <span className="text-[9px] uppercase tracking-widest text-[#658d71] font-bold">{label}</span>
            <span className="text-xs text-[#d8ceb3] font-bold truncate">{val}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecapHero;